class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.productGrid = document.querySelector('[data-collection-grid]');
    this.loadMoreButton = this.querySelector('button');
  }

  connectedCallback() {
    if(!this.productGrid || !this.loadMoreButton) return;
    this.loadMoreButton.addEventListener('click', async ()=> await this.loadMoreProducts());
  }

  async loadMoreProducts() {
    const url = this.loadMoreButton.getAttribute('action');

    if(!url) return;
    try {
      this.loadMoreButton.disabled = true;
      const response = await fetch(url);
      if(!response.ok) return;
      const result = await response.text();
      const parser = new DOMParser().parseFromString(result, 'text/html');
      const newGrid = parser.querySelector('[data-collection-grid]');
      const loadMore = parser.querySelector('load-more');
      if(!newGrid && !loadMore) return;      
      const newLayoutHTML = newGrid.innerHTML;
      this.productGrid.insertAdjacentHTML('beforeend', newLayoutHTML);
      this.outerHTML = loadMore.outerHTML;
      this.loadMoreButton.disabled = false;
    } catch (error) {
      console.log(error);
    }
  }
}

if(!customElements.get('load-more')) {
  customElements.define('load-more', LoadMore)
}

